import React from "react";
import { DetialComponent } from "./style";
import { Row, Col } from "react-bootstrap";
import Button from "components/button";
import ColorSelector from "./components/colorSelector";
import UsageSelector from "./components/usageSelector";
import InstallmentSelector from "./components/installmentSelector";
import NumberFormat from "components/numberFormat";

const Detial = ({
  product,
  selectedOptions,
  selectOption,
  next,
  prev,
  showPic
}) => {
  const optionView = () => {
    let options = product.item.options;
    return Object.keys(options).map((key, index) => {
      switch (key) {
        case "color":
          return (
            <ColorSelector
              key={index}
              colors={options[key]}
              selected={selectedOptions[key]}
              onChange={(data) => {
                selectOption(data);
              }}
            />
          );
        case "usage":
          return (
            <UsageSelector
              key={index}
              usages={options[key]}
              selected={selectedOptions[key]}
              onChange={(data) => {
                selectOption(data);
              }}
            />
          );
        case "installment":
          return (
            <InstallmentSelector
              key={index}
              installments={options[key]}
              selected={selectedOptions[key]}
              onChange={(data) => {
                selectOption(data);
              }}
            />
          );
        default:
          return null;
      }
    });
  };
  const selectedOptionsView = () => {
    return Object.keys(selectedOptions).map((key, index) => {
      return (
        <div key={index} className="grey-item">
          <span className="title">{selectedOptions[key].title}</span>
          <span className="value">
            {selectedOptions[key].added_price ? (
              <NumberFormat value={selectedOptions[key].added_price} />
            ) : (
              ""
            )}
          </span>
        </div>
      );
    });
  };
  const lastPrice = () => {
    let firstPrice = product.price;
    let plus = 0;
    Object.keys(selectedOptions).forEach((key) => {
      plus = plus + selectedOptions[key].added_price;
    });
    let sum = firstPrice + plus;
    return sum;
  };
  return (
    <DetialComponent>
      <Row>
        <Col sm={12} md={4} lg={3}>
          <aside className="side">
            <div className="image">
              <img src={`./images/${showPic}.jpg`} alt="product" />
            </div>
            <div className="content">
              <div className="labels">
                <span>{product?.title}</span>
              </div>
              <div className="price-area">
                <div className="grey-item">{product?.price_note}</div>
                {selectedOptionsView()}
                <div className="amount">
                  قابل پرداخت: <NumberFormat value={lastPrice()} />
                </div>
              </div>
            </div>
          </aside>
        </Col>
        <Col sm={12} md={8} lg={9}>
          {optionView()}
          <div className="buttons">
            <Button title="مرحله قبل" onClick={prev} />
            <Button
              title="تایید و ادامه"
              onClick={next}
              disabled={
                Object.keys(product.item.options).length !==
                Object.keys(selectedOptions).length
              }
            />
          </div>
        </Col>
      </Row>
    </DetialComponent>
  );
};
export default Detial;
